import { DependencyList, EffectCallback, useEffect } from 'react';
import { useIsMounted } from './useIsMounted';

/**
 * Customized effect hook that does is not executed on the first render.
 * @param effect The effect callback.
 * @param deps The effect dependencies.
 */
export const useUpdateEffect = (effect: EffectCallback, deps?: DependencyList) => {
  const isMounted = useIsMounted();

  useEffect(() => {
    if (isMounted()) {
      return effect();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
